<template>

<div  class="container-fluid">


     <!-- Modal CONFIRM -->
    <modalConfirm ref="confirmModal" />



<div class="card border-primary " >
<div class="card-header bg-primary text-white ">
    <h4 >
       <i style="color:yellow" class="fas fa-dolly mr-2" aria-hidden="true"></i>
          CONSEGNA ORDINE FORNITORE
    </h4>
</div>

<div class="card-body text-black ">


    <!-- ORDERS LIST -->
<div class=""  v-if = "type == 'A'">
    <supplier-orders @update="setProductsList"></supplier-orders>
</div>

<!-- PRODUCTS LIST -->
<div v-else >

  <div v-if="step==1">
        <button @click="type='A'" class="btn btn-secondary btn-block">      
          <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
          RITORNA ALLA RICERCA ORDINI
        </button>
       <h4 class="card-header_ border-success header_1 mt-2 mb-2">          
        <order-info v-bind:orderId="order.orderId"></order-info>
      </h4>
      <products-list v-bind:printLabels="true" @update="setDelivery" :key="productsKey" v-bind:orderId="order.orderId" v-bind:type="'confirm'"></products-list>       
 
  </div>
  <div v-else>

  <div class="d-flex_ align-items-center_">
             
             

          <h4 class="card-header_ border-success header_1 mt-2 mb-2">          
            <order-info v-bind:orderId="order.orderId"></order-info>
          </h4>
           <div v-if="step==2">
             <product-qty-delivery ref="delivery" @update="setForm" @step="step=1" @setStockMovement="setStockMovement"  :key="detailKey" v-bind:productId="product.productId" v-bind:order="order" v-bind:_stockMovementId="stockMovementId"></product-qty-delivery>         
           </div>           
           <div v-else-if="step==3">
            <cancel-btn  @click="setForm()" v-bind:text="'RITORNA A CONSEGNA PRODOTTI'" class="mb-1"></cancel-btn>
            <product-market v-bind:item="product" ></product-market>  
           </div>
           
          
          
  </div>         

</div>     
</div>   
</div>


<!-- PRIMARY -->
</div>    

<!-- MAIN DIV -->
</div>

</template>
<script>

import { mapGetters }      from 'vuex';
import supplierOrders      from '@/components/order/SupplierOrders.vue'
import productsList        from '@/components/order/OrderProducts.vue'
import orderInfo           from '@/components/order/OrderInfo.vue'
import productInfo         from '@/components/product/ProductInfo.vue'
import productQtyDelivery  from '@/components/order/ProductVariantsDelivery.vue'
import modalConfirm        from '@/components/modalDialog/ModalConfirm.vue'
import productMarket       from '@/components/backOffice/ready/tab/ProductMarketPlace.vue'
import cancelBtn           from '@/components/common/CancelBtn.vue'
export default {
  
  components: {supplierOrders,productsList,orderInfo,productQtyDelivery,productInfo ,modalConfirm,productMarket,cancelBtn},  
  

  data () {
    return {
    
      
      step         : 1,
      type         : 'A',
      product      : {'productId':0,},
      productKey   : 100,
      productsKey  : 200,
      detailKey    : 300,
      order        : {},
      orderInfoKey : 0,
    
    

      doc            : {},
      stockMovementId : 0
    
  }
  },

computed: 
{
  ...mapGetters(['company']),
},
mounted()
{},
created()
{},

/*
async beforeRouteLeave(to,from,next)
    {                
                if(this.$refs.delivery &&  this.$refs.delivery.btnBack == false)
                {
                const msg = 'OPERAZIONE DI REGISTRAZIONE CONSEGNA IN CORSO.  \n SI DESIDERA USCIRE COMUNQUE  ?' 
        
                 const confirmed = await this.$refs.confirmModal.show(
                    msg,
                    { title: 'ATTENZIONE' },1
                    )

                    if (!confirmed) return
                    this.$refs.confirmModal.close()

                }  

                next()
    },
*/
methods: 
{


  setStockMovement(stockMovementId)
  {
    this.stockMovementId = stockMovementId
    //console.log('DA FIGLIO',stockMovementId)
  },

  setProductsList(order)
  {

    this.doc   = {}
    this.order = order
    this.type = 'B'
    this.stockMovementId = 0

  }, 


  setDelivery(productId)
  {
    if(productId > 0)
    {
      this.step = 2
      this.product.productId = productId
      this.productKey++
      this.detailKey++
    }
    else
    {
      this.card = 'B'
    }
  },
  setProductPriceDetail(barcodes,sizes,counter)
  {
    this.product.barcodes = barcodes
    this.product.sizes = sizes
    this.product.counter = counter
    this.type = 'D'
  },
  setForm()
  {
    //this.stockMovementId = stockMovementId

    if(this.step==2 && this.company.Id == 26)
    {
      this.step = 3
    }
    else {
    
      this.productsKey++
      this.step = 1
      
    }
    

  },
 
 
 
  
      
}
    
}    
</script>

<style scoped>

.bold {
  font-weight: bolder;
}

h4,span {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}

.header_1 {
 
  background-color: beige;
}


</style>